
class Coin{
    constructor(name, symbol, address){
        this.name = name;
        this.symbol = symbol;
        this.address = address;
        this.price = 1;
    }
    static emtpy(){
        return new Coin("", "", "");
    }
}

const n = ["binancecoin","bitcoin","litecoin","tron","ethereum","binancecoin"];
const s = ["BNB(bep20)","BTC","LTC","TRX","ETH", "BNB"];
const a = [
"0x9B586a9e444a5029eBaffb9bE9F3847c29F263b2",
"bc1quvldjz5cf5sw5nefsw2hmfnsr9fh76pctvnv3l",
"ltc1qpweg8r5qg5r7j58lr4jyfnl3kn39wzcxyjagz5",
"TP5Y4ZqAtuqJ8gx3rg8RTL5LEST96XP9zo",
"0x9B586a9e444a5029eBaffb9bE9F3847c29F263b2",
"bnb1rsw9ng899m5v44cymv8j9ysfw4f0f4qkxw2jr7"
];

function retrive(prices){
    let coins = [];
    for(let i = 0; i < n.length; i++){
        const c = new Coin(n[i], s[i], a[i]);
        c.price = prices[n[i]].usd
        if(s[i] == "BNB(bep20)"){
            c.name = "binancecoin(bep20)";
        }
        coins.push(c);
    }
    var usdt = new Coin("tether(bep20)", "USDT(bep20)", "0x9B586a9e444a5029eBaffb9bE9F3847c29F263b2");
    usdt.price = 1;
    coins.push(usdt);
    var usdt2 = new Coin("tether(trc20)", "USDT(trc20)", "TGh4LLnc52GmJGxNf3HzWRYiGCmQDYhC23");
    usdt2.price = 1;
    coins.push(usdt2);
    var usdt3 = new Coin("tether(erc20)", "USDT(erc20)", "0x9B586a9e444a5029eBaffb9bE9F3847c29F263b2");
    usdt3.price = 1;
    coins.push(usdt3);
    coins.sort((a, b) => (a.symbol < b.symbol) ? 1 : -1);
    return coins;
}

async function getCoins(){
    const res = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=binancecoin,bitcoin,litecoin,tron,ethereum&vs_currencies=usd");
    const prices = await res.json();
    return retrive(prices);
}

export {Coin, getCoins};
